/* @flow */

import { createSelector } from '@reduxjs/toolkit';

import {
  passwordSupportLinkSection,
  passwordSupportResetSection,
  passwordSupportContactSection,
} from 'src/shared/app/authentication/constant/supportConstants';

/*
|------------------------------------------------------------------------------
| INPUTS
|------------------------------------------------------------------------------
*/

const segment = (state) => state.ui.support;

const getPasswordSection = (state) => segment(state).passwordSection;

/*
|------------------------------------------------------------------------------
| SELECTORS
|------------------------------------------------------------------------------
*/

export const isPasswordSupportLinkSectionShown: (
  state: Object,
) => boolean = createSelector(
  [getPasswordSection],
  (section: string): boolean => section === passwordSupportLinkSection,
);

export const isPasswordSupportResetSectionShown: (
  state: Object,
) => boolean = createSelector(
  [getPasswordSection],
  (section: string): boolean => section === passwordSupportResetSection,
);

export const isPasswordSupportContactSectionShown: (
  state: Object,
) => boolean = createSelector(
  [getPasswordSection],
  (section: string): boolean => section === passwordSupportContactSection,
);
